module.exports = __webpack_public_path__ + "img/en.948a85e7.png";